import { timeFormatLocale } from 'd3-time-format';
import dlv from 'dlv';

const requireLocale = require.context('d3-time-format/locale/', false, /(es-ES|en-US).*\.json$/);

function normalizeLocale(locale) {
	locale = locale.replace(/_/, '-');

	// Since d3-time-format doesn't have an entry for es-419.json replace it with es-ES
	if (locale === 'es-419' || locale === 'es-US') {
		locale = 'es-ES';
	}

	return locale;
}

function getLocale() {
	// TODO: Subscribe to the store instead of using Syn.Config.Framework.Locale
	let locale = normalizeLocale(dlv(window, 'Syn.Config.Framework.Locale') || 'en_US');
	try {
		return requireLocale(`./${locale}.json`);
	}
	catch (e) {
		console.warn(`@os/localtime: Could not find locale file ${locale}.json`);
		return requireLocale('./en-US.json');
	}
}

export default timeFormatLocale(getLocale());
